const SecretsSkeleton = () => (
  <div className="space-y-4 p-4 md:p-8 animate-pulse">
    {[1, 2, 3, 4].map((i) => (
      <div key={i} className="flex flex-col md:flex-row gap-4">
        <div className="w-full md:w-1/3 h-12 bg-white/[0.02] rounded-xl border border-white/5" />
        <div className="w-full md:w-1/2 h-12 bg-white/[0.02] rounded-xl border border-white/5" />
      </div>
    ))}
  </div>
);

export default SecretsSkeleton